import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Pinta el overlay en document.body. Si vive adentro de main/card (overflow,
 * transform, z-index del header), `fixed` no cubre el chrome y el tap se filtra.
 */
export function ModalPortal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
